import { toInteger } from 'lodash';
import { createCanvas } from '@/utils/file-kit';
import type { ILayerProps, IMarkupLayerProps } from '@/version-types';
import { MarkupCreator } from '../utils/markup-create';

/**
 * 对标注画布应用图层变换（翻转）并可选地应用透明度
 */
const applyLayerTransform = (
    layer: ILayerProps,
    baseImage: HTMLImageElement | HTMLCanvasElement,
    opacity = 1,
    scale = 1,
) => {
    const { width, height } = layer;
    const {
        imageTransform: { flipH, flipV },
    } = layer.data as IMarkupLayerProps;

    const resultWidth = Math.max(1, toInteger(width * scale));
    const resultHeight = Math.max(1, toInteger(height * scale));
    const offsetX = 0;
    const offsetY = 0;
    const originImgWidth = resultWidth;
    const originImgHeight = resultHeight;

    let imgOffsetX = resultWidth / 2;
    let imgOffsetY = resultHeight / 2;

    if (flipH) {
        imgOffsetX = imgOffsetX - offsetX;
    } else {
        imgOffsetX = imgOffsetX + offsetX;
    }

    if (flipV) {
        imgOffsetY = imgOffsetY - offsetY;
    } else {
        imgOffsetY = imgOffsetY + offsetY;
    }

    let rotate = 0;
    if (flipH) {
        rotate = -rotate;
    }
    if (flipV) {
        rotate = -rotate;
    }

    const { canvas: destCanvas, ctx: destCtx } = createCanvas(resultWidth, resultHeight);

    destCtx.globalAlpha = opacity;
    destCtx.translate(imgOffsetX, imgOffsetY);
    destCtx.rotate((rotate * Math.PI) / 180);
    destCtx.scale(flipH ? -1 : 1, flipV ? -1 : 1);
    if (baseImage.width > 0 && baseImage.height > 0) {
        destCtx.drawImage(baseImage, -originImgWidth / 2, -originImgHeight / 2, originImgWidth, originImgHeight);
    }

    return destCanvas;
};

/**
 * 将标注图层内容渲染到 Canvas
 *
 * @param layer - 图层属性
 * @param identity - 框架实例标识
 * @param globalAlpha - 是否应用透明度，默认 true
 */
export const renderLayerContentToCanvas = async (
    layer: ILayerProps,
    identity: string,
    globalAlpha = true,
    scale = 1,
): Promise<HTMLCanvasElement> => {
    const { opacity } = layer;

    const baseImage = await MarkupCreator.create(layer, identity, scale);

    const layerCanvas = applyLayerTransform(layer, baseImage, globalAlpha ? opacity : 1, scale);
    return layerCanvas;
};
